export function getTranslations() {
    return JSON.parse(document.getElementById('strings-container').getAttribute('data-strings'));
}

export function getBookingEngineTranslations() {
    return JSON.parse(document.getElementById('translations-container')
        .getAttribute('data-strings'));
}

export const capitalizeFirstWord = (phrase) => {
    return phrase.charAt(0).toUpperCase() + phrase.slice(1);
}

export const getApartmentIdFromURL = () => {
    const apartmentSlug = window.location.pathname;
    const lastDigitsFromPathName = /[^-](\d*)$/g;
    const apartmentId = parseInt(apartmentSlug.match(lastDigitsFromPathName)[0]);

    return apartmentId;
}

export const formatHeading = (name) => {
    const matchingPhrase = name.match(/[^.-]*$/g)[0];

    //First letter uppercase
    return matchingPhrase.charAt(0).toUpperCase() + matchingPhrase.slice(1).toLowerCase();
}

export const useFetch = (url, body = null, onSuccess) => {
    const locationUrl = location.origin + '/' + url

    return fetch(
        locationUrl,
        {
            method: 'post',
            headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        },
    )
        .then(response => {
            return response.json()
        })
        .then(res => {
            if (res.status && onSuccess !== undefined) {
                onSuccess(res.payload)
            }
        })
        .catch(error => {
            alert(error)
        })
}

export const getBookingPeriod = (bookingNights, translations) => {
    if (bookingNights === 1) {
        return bookingNights + ' ' + translations['night']
    } else if (bookingNights < 5) {
        return bookingNights + ' ' + translations['nights']
    } else {
        return bookingNights + ' ' + translations['nights_those']
    }
}

export const numberFormat = (value) => new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
    currencyDisplay: 'code'
}).format(value);

export const showPriceWithCurrency = (price) => {
    let lang = document.documentElement.getAttribute('lang');
    let currency = 'PLN';

    if (lang === null || typeof lang === "undefined") {
        lang = 'pl';
    }

    if (lang !== 'pl') {
        price = (price / window.EURO_RATE).toFixed(2);
        currency = 'EUR';
    }

    return {
        price: price,
        currency: currency,
        formatted: price + " " + currency,
    }
}
